import { Stack, Tooltip } from '@mui/material';
import { EventOutlined } from '@mui/icons-material';
import { StackedTextCell, TopLineTypography } from '@retail/components';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { getLLDate } from '@retail/utils';
import { DateRange } from '../DateRange';

interface Props {
  value: string;
  validFrom?: Date;
  validTo?: Date;
  showDates: boolean;
}

export function DiscountValueCell({ value, validFrom, validTo, showDates }: Props) {
  const t = useCalculusTFunction();

  if (showDates) {
    return (
      <StackedTextCell
        topLine={value}
        bottomLine={<DateRange validFrom={validFrom} validTo={validTo} />}
      />
    );
  }

  return (
    <Stack flexDirection="row" alignItems="center" gap={0.5}>
      {/* @ts-ignore */}
      <TopLineTypography variant="subtitle2" component="span">
        {value}
      </TopLineTypography>
      {validTo && (
        <Tooltip
          title={t('calculus.discounts.expiresTooltip', {
            validTo: getLLDate(validTo),
            validFrom: getLLDate(validFrom),
          })}
        >
          <EventOutlined fontSize="small" color="action" />
        </Tooltip>
      )}
    </Stack>
  );
}
